export class CalendarAppTypeSelector {

   constructor(params) {
      this.panel = document.createElement('div');
      this.panel.classList.add('app-type-selector');
   }

   setAppTypes(types, selected) {

      this.panel.empty();
      for (let id in types) {
         const type = types[id];
         if (type.allowedTo.view) {
            let typeElement = this.panel.createElement('div', 'app-type');
            typeElement.dataset.appTypeId = type.id;
            if (selected.includes(type.id) || selected === 'all') typeElement.classList.add('selected');
            let title = typeElement.createElement('div', 'title');
            title.style.backgroundColor = type.color;
            title.setStyles(type.css);
            title.innerHTML = type.title;
            typeElement.addEventListener('click', (event) => {
               typeElement.classList.toggle('selected');
            });
         }
      }

   }

   getSelected() {
      return Array.from(this.panel.querySelectorAll('.app-type.selected'), item => parseInt(item.dataset.appTypeId));
   }

   getHtmlElement() {
      return this.panel;
   }

}
